/**
 * Pages légales et contact de chaque marque, relevés sur les sites publics le 07/10/2026.
 * Aucun des deux sites n'a de CGU : on ne renvoie donc qu'à la confidentialité et aux mentions légales.
 * Café Crème Club n'affiche pas d'adresse e-mail publique : le contact passe par la page Contact.
 */
import { brandBySlug, BRAND_SKINS, type BrandSkin, type BrandSlug } from "./brandSkins";

export type BrandLegal = {
  slug: BrandSlug;
  name: string;
  siteUrl: string;
  privacyUrl: string;
  legalNoticeUrl: string;
  contactUrl: string;
  contactEmail: string | null;
};

export const BRAND_LEGAL: Record<BrandSlug, BrandLegal> = {
  "cafe-creme-club": {
    slug: "cafe-creme-club",
    name: BRAND_SKINS["cafe-creme-club"].name,
    siteUrl: "https://cafe-creme.club",
    privacyUrl: "https://cafe-creme.club/confidentialite",
    legalNoticeUrl: "https://cafe-creme.club/mentions-legales",
    contactUrl: "https://cafe-creme.club/contact",
    contactEmail: null,
  },
  launchpad: {
    slug: "launchpad",
    name: BRAND_SKINS.launchpad.name,
    siteUrl: "https://launch-pad.fr",
    privacyUrl: "https://launch-pad.fr/confidentialite",
    legalNoticeUrl: "https://launch-pad.fr/mentions-legales",
    contactUrl: "https://launch-pad.fr/contact",
    contactEmail: "contact@launch-pad.fr",
  },
};

/** Sans marque connue : Café Crème Club, comme brandAppName(null). */
export function brandLegal(brand: BrandSkin | BrandSlug | string | null | undefined): BrandLegal {
  const slug = typeof brand === "string" ? brandBySlug(brand)?.slug : brand?.slug;
  return BRAND_LEGAL[slug ?? "cafe-creme-club"];
}
